import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TRANSLATION_KEYS } from '../../i18n/translation-keys';
import { SHARED_MODULES } from '../../shared';

export interface ConfirmModalData {
  title?: string;
  message?: string;
  icon?: string;
}

@Component({
  selector: 'app-confirm-modal',
  imports: [SHARED_MODULES],
  templateUrl: './confirm-modal.html',
  styleUrl: './confirm-modal.scss',
})
export class ConfirmModal {
  protected readonly data: ConfirmModalData = inject<ConfirmModalData | null>(MAT_DIALOG_DATA, { optional: true }) ?? {};

  protected readonly translationKeys = TRANSLATION_KEYS;
}
